import React, { Component } from 'react';
import queryString from 'query-string';
import { Form, Field } from 'react-final-form';
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context.js';
import { ProjectDetails } from "../parts/details.js";
import { ProjectTags } from "../parts/tags.js";
import { ProvisionResources } from "../parts/resources.js";
import { ERRORSTYLE } from "../util/constants";

// TODO: replace this field validator with something intelligent;
// the current implementation is hard-coded to ivy groups only.
const groupRegex = value => {
  if (!value) {
    return "Required"
  }
  if (value.match(/^ivy-(tst|hip|frp|itr|cui|dbg)-[a-z0-9]{3,6}$/)) {
    return undefined
  }
  return "Invalid group name, must match /^ivy-(tst|hip|frp|itr|cui|dbg)-[a-z]{3,6}$/"
};

export default class ProvisionContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            project: null,
            active: null
        };
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    updateState(proj) {
      let active = {};
      let resources = [];
      const cres = this.context.config.resources;
      if (proj.resources) {
        proj.resources.forEach((res, idx) => {
          if (!res.state || res.state === 1) {
            let ridx = res.index;
            if (!ridx) {
              ridx = 0;
              res.index = ridx;
            }
            active[ridx] = false;
            let pfields = [];
            for (let i = 0; i < cres.length; i++) {
              let rtype = cres[i]
              if (rtype.name === res.name) {
                if (rtype.provisioned_booleans) pfields = pfields.concat(rtype.provisioned_booleans);
                if (rtype.provisioned_integers) pfields = pfields.concat(rtype.provisioned_integers);
                if (rtype.provisioned_strings) pfields = pfields.concat(rtype.provisioned_strings);
                break;
              }
            }
            res.provision_fields = pfields;
            resources.push(res)
          }
        });
      }
      proj.resources = resources;
      this.setState({
        project: proj,
        active: active
      });
    }

    componentDidMount() {
      const values = queryString.parse(this.props.location.search);
      const pid = values.project;
      fetch(`/api/project/${pid}`)
        .then(res => res.json())
        .then(proj => {
          this.updateState(proj);
        });
    }

    handleCheckboxChange = (e, res) => {
      let { active } = this.state;
      let idx = res.index;
      if (!idx) { idx = 0 }
      active[idx] = !active[idx];

      this.setState({ active });
    }

    onSubmit = async (values) => {
      const { active, project } = this.state;
      const { config, setGlobalError } = this.context;
      const resources = [];
      const ptags = [];
      const denied = values["denied"];
      project.resources.forEach(res => {
        if (active[res.index]) {
          const deny = (denied ? denied.includes(res.name) : false);
          let provision = {
            index: res.index,
            provision: !deny
          };
          if (denied && denied.includes(res.name)) {
            provision.comment = values[res.index + "-reason"];
          } else {
            provision.tags = []
            res.provision_fields.forEach(field => {
              provision.tags.push({
                name: field,
                value: values[res.index + "-" + field]
              })
            });
          }
          resources.push(provision);  
        }
      });
      config.provisioner_project_tags.forEach(tag => {
        if (values[tag]) {
          ptags.push({
            name: tag,
            value: values[tag + "-value"],
          })
        }
      });
      let putObj = {
        resources: resources,
        tags: ptags,
      };
      const endpoint = `/api/project/${project.id}/provision`
      const res = await fetch(endpoint, {
        method: 'PUT',
        body: JSON.stringify(putObj),
        headers:{
          'Content-Type': 'application/json'
        }
      });
      if (!res || !res.ok) {
        let message = null;
        try {
          const errdata = await res.json();
          message = `error ${res.status} provisioning resources: ${errdata.message}`;
        } catch(error) {
          message = `unknown error provisioning resources, try again later`;
        }
        setGlobalError(message)
      }
      this.props.navigate(`project/${this.state.project.id}`);
    }

    render() {
        if (this.state.project == null) {
            return null
        }

        const { project, active } = this.state;
        const { config, person } = this.context;
        const Condition = ({ when, is, unchecked, children }) => (
          <Field name={when} subscription={{ value: true }}>
            {({ input: { value } }) => (value === is ? children : <p>{unchecked}</p>)}
          </Field>
        )

        return (
          <div style={{padding: "20px"}}>
          <Styles>
            <h1>{project.title}</h1>
            <div>{project.description}</div>
            <h2>Sensitivity</h2>
            <table className="project-tags">
                <tbody>
                {
                    project.flags && project.flags.map((flag) =>
                    <tr key={flag.name}>
                        <td className="project-sensitivity">{flag.name}</td>
                    </tr>
                )}
                </tbody>
            </table>
            <ProjectDetails project={project} authuser={person} config={config}/>
            <ProjectTags project={project}/>
            <Form
              onSubmit={this.onSubmit}
              render={({handleSubmit, form, submitting, pristine, values, invalid }) => (
                <form style={{width: "90%"}}
                  onSubmit={event => {
                    handleSubmit(event).then(() => {
                      form.reset();
                    });
                  }}
                >
                  <h2>Provisioned Tags</h2>
                  <table className="project-tags">
                      <tbody>
                        <tr key="headings">
                          <td className="headings-row">Set</td>
                          <td className="headings-row">Name</td>
                          <td className="headings-row">Value</td>
                        </tr>
                        {config.provisioner_project_tags.map((tag, idx) =>
                        <tr key={idx}>
                          <td>
                            <Field
                                name={tag}
                                component="input"
                                type="checkbox"
                            />
                          </td>
                          <td>{tag}</td>
                          <td>
                            <Condition when={tag} is={true} unchecked="(not checked)">
                              <Field
                                name={tag + "-value"}
                                validate={groupRegex}
                                component="input"
                                type="text"
                                placeholder="value"
                              >
                                {({ input, meta }) => (
                                  <div>
                                    <input {...input} type="text" placeholder="value" />
                                    {meta.error && meta.touched && <span style={ERRORSTYLE}>{meta.error}</span>}
                                  </div>
                                )}
                              </Field>
                            </Condition>
                          </td>
                        </tr>
                      )}
                      </tbody>
                  </table>
                  <h2>Please check boxes of resources provisioned or denied:</h2>
                  <ProvisionResources
                    project={project}
                    active={active}
                    handleCheckboxChange={this.handleCheckboxChange}
                  />
                  <button type="submit" disabled={pristine || invalid || submitting || values.length === 0 }>
                    Provision
                  </button>
                </form>
              )}
            />
          </Styles>
        </div>
        );
    }
}
